function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint-disable no-unused-expressions */
import Vue from 'vue';
import { sync, call } from 'vuex-pathify';
import EventBus from '@assets/scripts/event-bus';

var Form = /*#__PURE__*/function () {
  function Form() {
    _classCallCheck(this, Form);
  }

  _createClass(Form, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-form', {
        template: "<div class=\"roche-form\" :class=\"[classes, $attrs['is-genentech-form'] ? 'genentech' : '']\">\n          <slot name=\"default\"></slot>\n          <slot name=\"occupation\" v-bind:confirmOccupation=\"confirmOccupation\"></slot>\n          <slot name=\"temp-hcp\" v-bind:addProduct=\"addProduct\" v-bind:removeProduct=\"removeProduct\"></slot>\n          <slot name=\"temp-patient\"></slot>\n        </div>",
        data: function data() {
          return {
            stepsEL: []
          };
        },
        props: ['classes'],
        computed: _objectSpread(_objectSpread({}, sync('forms/*')), {}, {
          urlHash: function urlHash() {
            return window.btoa(JSON.stringify({
              currentStep: this.currentStep,
              currentSubStep: this.currentSubStep
            }));
          }
        }),
        mounted: function mounted() {
          var _this = this;

          return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var ctr, urlParams, product, productStep, isLocalSite;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    // Reset form from Localstorage
                    ctr = _this.$attrs.countries && _this.$attrs.countries !== 'all' ? _this.$attrs.countries : _this.$store.state.ctr;

                    if (_this.$attrs['is-genentech-form']) {
                      ctr = 'US';
                    }

                    _this.$store.commit('forms/SET_FORM', {
                      ctr: ctr,
                      flaggedcountries: _this.$attrs.flaggedcountries ? _this.$attrs.flaggedcountries : [],
                      flaggedcountriesmap: _this.$attrs.flaggedcountriesmap || [],
                      products: [{
                        index: 1,
                        product: {
                          label: '',
                          value: ''
                        }
                      }]
                    });

                    _this.$store.commit('forms/SET_GENENTECH_DATA', {
                      isGenentechForm: _this.$attrs['is-genentech-form'],
                      replacementProductIds: _this.$attrs['genentech-replacement-product-ids']
                    });

                    _this.endpoint = _this.$attrs.endpoint;
                    _this.id = _this.$attrs.id;
                    _this.title = _this.$attrs.title;
                    _this.notification = !!_this.$attrs.notification;
                    _this.redirect = _this.$attrs.redirect || _this.redirect;
                    _this.submitted = false;
                    _this.fallbackValue = _this.$attrs.fallback || null;

                    if (window.analytics) {
                      window.analytics.step = String(0);
                      window.analytics.isSubmitted = String(false);
                      window.digitalData.page.formInfo.formName = _this.id;
                    }

                    document.body.classList.add('form-page');

                    if (_this.id === 'medical-information') {
                      urlParams = new URLSearchParams(window.location.search);
                      product = urlParams.get('p');

                      if (product && product.length > 0) {
                        // remove step Product Details
                        productStep = document.querySelector('section[form-step="Product Details"]');
                        productStep.remove();
                        EventBus.$emit('update-steps'); // set product in form

                        _this.$store.commit('forms/SET_FORM', _objectSpread(_objectSpread({}, _this.form), {}, {
                          product: product
                        }));
                      }
                    }

                    _this.setLabels();

                    _this.readFormSteps();

                    isLocalSite = document.documentElement.lang.length > 2;

                    if (isLocalSite) {
                      if (window.analytics) {
                        window.analytics.step = String(1);
                      }

                      _this.$store.dispatch('forms/loadProducts');
                    }

                    EventBus.$on('step-changed', function () {
                      _this.$root.$emit('step-changed');
                    });

                    _this.setStep(0);

                    window.onhashchange = _this.decodeUrlHash;

                  case 21:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }))();
        },
        watch: {
          currentStep: function currentStep(newValue) {
            this.setStep(newValue);
          }
        },
        methods: {
          decodeUrlHash: function decodeUrlHash() {
            if (window.location.hash) {
              var hash = window.atob(window.location.hash.replace('#', ''));

              var _JSON$parse = JSON.parse(hash),
                  currentStep = _JSON$parse.currentStep,
                  currentSubStep = _JSON$parse.currentSubStep;

              if (currentStep) {
                this.currentStep = parseInt(currentStep, 10);
              }

              if (currentSubStep) {
                this.currentSubStep = parseInt(currentSubStep, 10);
              }
            }
          },
          readFormSteps: function readFormSteps() {
            this.stepsEL = document.querySelectorAll('[form-step]');
            var number = 0;
            this.steps = _toConsumableArray(this.stepsEL).map(function (el, i) {
              if (el.getAttribute('form-step')) {
                number++;
              }

              var hiddenOnShow = !!el.querySelector('[hideprogressbar="true"]');
              return {
                name: el.getAttribute('form-step'),
                index: i,
                hidden: !el.getAttribute('form-step'),
                hiddenOnShow: hiddenOnShow,
                number: number,
                substeps: _toConsumableArray(el.querySelectorAll('form')).length
              };
            });
          },
          setLabels: function setLabels() {
            if (this.$attrs.labels) {
              if (typeof this.$attrs.labels === 'string') {
                var replaceAll = function replaceAll(str, find, replace) {
                  return str.replace(new RegExp(find, 'g'), replace);
                };

                var overrideLabels = this.$attrs.labels.split(',').reduce(function (acc, label) {
                  // prettier-ignore
                  label = replaceAll(label, "{|}|'|\"", '').trim().split(':');

                  if (label[1].length) {
                    acc[label[0]] = label[1].trim();
                  }

                  return acc;
                }, {});
                this.labels = _objectSpread(_objectSpread({}, this.labels), overrideLabels);
              } else {
                this.labels = _objectSpread(_objectSpread({}, this.labels), this.$attrs.labels);
              }
            }
          },
          setStep: function setStep(index) {
            var _this2 = this;

            if (index < this.currentStep) {
              this.currentStep = index;
            }

            _toConsumableArray(this.stepsEL).forEach(function (el, i) {
              if (i === _this2.currentStep) el.style.display = 'block';else el.style.display = 'none';
            });

            window.history.pushState(null, null, "#".concat(this.urlHash));
            EventBus.$emit('step-changed');
          },
          next: function next() {
            this.setStep(this.currentStep + 1);
          },
          prev: function prev() {
            this.setStep(this.currentStep - 1);
          },
          nextPage: call('forms/nextPage'),
          confirmOccupation: function confirmOccupation() {
            if (!this.form.occupation) {
              return;
            }

            this.readFormSteps();

            if (this.form.occupation === 'patientCaregiver') {
              window.digitalData.page.formInfo.formName = "".concat(this.id, "_").concat(this.form.occupation);
            } else {
              window.digitalData.page.formInfo.formName = "".concat(this.id, "_other");
            }

            if (window.analytics) {
              window.analytics.totalSteps = String(this.steps.length);
            }

            this.nextPage();
          },
          getElementBoundries: function getElementBoundries(element) {
            return element.getBoundingClientRect();
          },
          addProduct: function addProduct(event) {
            var previousProductFormElement = event.target.closest('.grid-x').previousElementSibling;
            var productsIndex = this.form.products.length;

            var _this$getElementBound = this.getElementBoundries(previousProductFormElement),
                bottom = _this$getElementBound.bottom;

            this.form.products = [].concat(_toConsumableArray(this.form.products), [{
              index: productsIndex + 1
            }]);
            this.$nextTick(function () {
              window.scrollBy({
                top: bottom - 100,
                behavior: 'smooth'
              });
            });
          },
          removeProduct: function removeProduct(index) {
            this.form.products.splice(index, 1);
            this.form.products.map(function (product, i) {
              product.index = i + 1;
              return product;
            });
          }
        }
      });
    }
  }]);

  return Form;
}();

export default Form;